import { connect } from "react-redux";

import { fetchAccountAvailableDomainsPools } from "features/Accounts/state/thunks/accountDomainsThunk";
import { setSelectedDomain, setSelectedDomainType } from "features/Accounts/state/slices/accountDomainsSlice";
import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import { DomainsSection } from "../../../DomainsSection/DomainsSection";
import { bindAction } from "../../../../interfaces";
import { bindActionCreators } from "redux";

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  return {
    availableDomains: state.accounts.availableDomains,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getAvailableDomains: bindAction(fetchAccountAvailableDomainsPools, dispatch),
  setSelectedDomainAction: bindAction(setSelectedDomain, dispatch),
  setSelectedDomainTypeAction: bindActionCreators(setSelectedDomainType, dispatch),
});

/* istanbul ignore next */
const connector = connect(mapStateToProps, mapDispatchToProps);

const DomainsSectionContainer = connector(DomainsSection);
export default DomainsSectionContainer;
